/**
 * ExecutionDetailPage
 *
 * Page wrapper for the ExecutionDetail component.
 */
import { useParams } from 'react-router-dom';
import { ExecutionDetail } from '../components/execution/ExecutionDetail';

export default function ExecutionDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4">
        <div className="max-w-4xl mx-auto py-8">
          <div className="text-center py-12">
            <div className="text-6xl mb-4">❌</div>
            <h2 className="text-xl font-semibold mb-2">Invalid Execution ID</h2>
            <p className="text-muted-foreground">
              No execution ID was provided in the URL.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <div className="max-w-4xl mx-auto py-8">
        <ExecutionDetail executionId={id} />
      </div>
    </div>
  );
}
